import { PageController } from '@client/components/_core/layout/PageController';
import { ComplaintFlagEdit } from '@client/components/complaints/ComplaintFlagEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId')(
    {
        params: {
            parse({ complaintFlagId }) {
                return {
                    complaintFlagId: BigInt(complaintFlagId),
                };
            },
        },
        staticData: {
            presentation: 'overlay',
            metadata: {
                title: 'Edit flag',
            },
        },
        component: RouteComponent,
    },
);

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ComplaintFlagEdit action={['edit', Route.useParams().complaintFlagId]} />
        </PageController>
    );
}
